export default import.meta.ROLLUP_FILE_URL_9ClfA7nam4J4P8m2Mi2dvg